import { render, staticRenderFns } from "./ExpensesMarketingCosts.vue?vue&type=template&id=9fd747c0"
import script from "./ExpensesMarketingCosts.vue?vue&type=script&lang=js"
export * from "./ExpensesMarketingCosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fd747c0')) {
      api.createRecord('9fd747c0', component.options)
    } else {
      api.reload('9fd747c0', component.options)
    }
    module.hot.accept("./ExpensesMarketingCosts.vue?vue&type=template&id=9fd747c0", function () {
      api.rerender('9fd747c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/StoryMode/FinancialPlan/Pages/ExpensesMarketingCosts.vue"
export default component.exports